import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  IconButton,
  Popover,
  TextField as MuiTextField,
  MenuItem,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { useDispatch, useSelector } from "react-redux";
import { updateElement } from "../../store/formSlice";

const fieldOptions = [
  "SubcontractorName",
  "FirstName",
  "LastName",
  "Email",
  "PersonalNo",
  "Mobile",
  "Address",
  "City",
  "Zipcode",
  "RecipientRole",
  "ClientName",
  "ClientAddress",
];

const SettingsPopover = ({ anchorEl, onClose, node, updateAttributes }) => {
  const open = Boolean(anchorEl);

  const handleOK = () => {
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        style: { width: "250px" }, // Make the popover smaller
      }}
    >
      <div style={{ padding: "10px" }}>
        <MuiTextField
          label="Placeholder"
          defaultValue={node.attrs.placeholder}
          onChange={(e) => updateAttributes({ placeholder: e.target.value })}
          fullWidth
          margin="normal"
          size="small" // Make the text field smaller
        />
        <MuiTextField
          label="Height"
          defaultValue={node.attrs.height}
          onChange={(e) => updateAttributes({ height: e.target.value })}
          fullWidth
          margin="normal"
          size="small"
        />
        <MuiTextField
          label="Width"
          defaultValue={node.attrs.width}
          onChange={(e) => updateAttributes({ width: e.target.value })}
          fullWidth
          margin="normal"
          size="small"
        />
        <MuiTextField
          label="Font Size"
          defaultValue={node.attrs.fontSize}
          onChange={(e) => updateAttributes({ fontSize: e.target.value })}
          fullWidth
          margin="normal"
          size="small"
        />
        <MuiTextField
          select
          label="Mapped DB Column"
          defaultValue={node.attrs.mappingField}
          onChange={(e) => updateAttributes({ mappingField: e.target.value })}
          fullWidth
          margin="normal"
          size="small" // Make the select field smaller
        >
          {fieldOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </MuiTextField>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleOK}
            size="small" // Make the button smaller
          >
            OK
          </Button>
        </div>
      </div>
    </Popover>
  );
};

// FieldNodeView component
const FieldNodeView = ({ node, updateAttributes, extension, editor }) => {
  const editable = extension.options.editable;
  const isBorder = extension.options.isBorder;
  const dispatch = useDispatch();

  console.log(extension);
  console.log("FieldNodeView props:", {
    node,
    updateAttributes,
    editable,
    isBorder,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (attributes) => {
    updateAttributes(attributes);
    if (extension?.options?.onEditorInlineFieldsChange) {
      const updatedField = { ...node.attrs, ...attributes };
      let updatedFields = extension.options.inlineFields || [];
      const existingFieldIndex = updatedFields.findIndex(
        (field) => field.uuid === updatedField.uuid
      );

      if (existingFieldIndex === -1) {
        updatedFields = [...updatedFields, updatedField];
      } else {
        updatedFields = updatedFields.map((field, index) =>
          index === existingFieldIndex ? updatedField : field
        );
      }

      console.log("start...");
      console.log(updatedFields);
      console.log("end...");

      extension.options.inlineFields = updatedFields;
      extension.options.onEditorInlineFieldsChange(updatedFields);
    }
  };

  const handleInputChange = (event) => {
    const updatedValue = event.target.value;
    //for text update in props
    updateAttributes({ defaultValue: updatedValue });
    editor.view.dispatch(editor.state.tr.setMeta("ATTRIBUTE_UPDATE", true));
    const updatedEditorHtml = editor.getHTML();
    console.log(updatedEditorHtml, "updatedEditorHtml");
    const editorContent = (extension.options.elementProps.text =
      updatedEditorHtml);
    console.log(editorContent, "editorContent");

    const updatedField = { ...node.attrs, value: updatedValue };

    let updatedFields = extension.options.inlineFields || [];
    const existingFieldIndex = updatedFields.findIndex(
      (field) => field.uuid === node.attrs.uuid
    );

    if (existingFieldIndex === -1) {
      updatedFields = [...updatedFields, updatedField];
    } else {
      updatedFields = updatedFields.map((field, index) =>
        index === existingFieldIndex ? updatedField : field
      );
    }

    extension.options.inlineFields = updatedFields;
    // extension.options.onEditorInlineFieldsChange(updatedFields);

    console.log("updated fields....");
    console.log(updatedFields);

    console.log(extension.options.elementId);
    console.log(extension.options.elementProps);
    // Dispatch the updateElement action
    dispatch(
      updateElement({
        id: extension.options.elementId,
        element: {
          ...extension.options.elementProps,
          elementId: extension.options.elementId,
          inlineFields: updatedFields,
        },
      })
    );
  };

  const inputType = node.attrs.type === "date" ? "date" : "text";
  const currentDate = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
  return (
    <NodeViewWrapper
      style={{
        display: "inline-flex",
        alignItems: "center",
        marginRight: isBorder ? "10px" : "-5px",
      }}
    >
      <input
        type={inputType}
        placeholder={node.attrs.placeholder}
        defaultValue={
          inputType === "date" ? currentDate : node.attrs.defaultValue
        }
        style={
          isBorder
            ? {
              width: node.attrs.width || "auto",
              height: node.attrs.height || "24px",
              border: "1px solid #ccc",
              padding: "2px 5px",
              borderRadius: "4px",
              //fontSize: node.attrs.fontSize || "14px",
              fontSize: "inherit",
              fontFamily: "inherit", // Inherit font family
              fontWeight: "inherit", // Inherit font weight
              fontStyle: "inherit", // Inherit font style
            }
            : {
              height: node.attrs.height || "24px",
              fieldSizing: "content",
              border: "none",
              outline: "none",
              margin: "0 1ch",
              //fontSize: node.attrs.fontSize || "14px", 
              fontSize: "inherit", // Inherit font size
              backgroundColor: "transparent",
              fontFamily: "inherit", // Inherit font family
              fontWeight: "inherit", // Inherit font weight
              fontStyle: "inherit", // Inherit font style
            }
        }
        size={node.attrs.defaultValue?.length || 1}
        contentEditable={false}
        onChange={handleInputChange}
      />
      {editable && (
        <IconButton
          size="small"
          onClick={handleSettingsClick}
          style={{ marginLeft: "5px" }}
        >
          <SettingsIcon fontSize="inherit" />
        </IconButton>
      )}
      <SettingsPopover
        anchorEl={anchorEl}
        onClose={handleSettingsClose}
        node={node}
        updateAttributes={handleUpdate}
      />
    </NodeViewWrapper>
  );
};

// InlineFields extension
export const InlineFields = Node.create({
  name: "inlineFields",

  group: "inline",

  inline: true,

  atom: true,

  addOptions() {
    return {
      editable: true,
      inlineFields: [],
      onEditorInlineFieldsChange: () => { },
    };
  },

  addAttributes() {
    return {
      type: {
        default: "text", // or 'date'
      },
      placeholder: {
        default: "",
      },
      defaultValue: {
        default: "",
      },
      label: {
        default: "",
      },
      mappingField: {
        default: "",
      },
      dropdownValue: {
        default: "",
      },
      width: {
        default: "100px",
      },
      height: {
        default: "30px",
      },
      uuid: {
        default: null,
        keepOnUpdate: true,
      },
      fontSize: {
        default: "14px",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="inlineFields"]',
        getAttrs: (element) => {
          return {
            type: element.getAttribute("data-field-type"),
            placeholder: element.getAttribute("data-placeholder"),
            defaultValue: element.getAttribute("data-default-value"),
            label: element.getAttribute("data-label"),
            mappingField: element.getAttribute("data-mapping-field"),
            dropdownValue: element.getAttribute("data-dropdown-value"),
            width: element.getAttribute("data-width"),
            height: element.getAttribute("data-height"),
            uuid: element.getAttribute("data-uuid"),
            fontSize: element.getAttribute("data-fontSize"),
          };
        },
      },
    ];
  },

  renderHTML({ node }) {
    return [
      "span",
      mergeAttributes(
        { "data-type": "inlineFields" },
        {
          "data-field-type": node.attrs.type,
          "data-placeholder": node.attrs.placeholder,
          "data-default-value": node.attrs.defaultValue,
          "data-label": node.attrs.label,
          "data-mapping-field": node.attrs.mappingField,
          "data-dropdown-value": node.attrs.dropdownValue,
          "data-height": node.attrs.height,
          "data-width": node.attrs.width,
          "data-uuid": node.attrs.uuid,
          "data-fontSize": node.attrs.fontSize,
        }
      ),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer((props) => (
      <FieldNodeView
        {...props}
        getEditable={() => this.options.editable}
        editor={this.editor}
      />
    ));
  },

  addCommands() {
    return {
      setTextField:
        (attributes) =>
          ({ chain, state }) => {
            const uuid = attributes.uuid || uuidv4();
            const newField = { ...attributes, type: "text", uuid };
            this.options.inlineFields = [...this.options.inlineFields, newField];
            this.options.onEditorInlineFieldsChange(this.options.inlineFields);
            return chain()
              .insertContent({
                type: this.name,
                attrs: newField,
              })
              .run();
          },
      setDatePicker:
        (attributes) =>
          ({ chain, state }) => {
            const uuid = attributes.uuid || uuidv4();
            const newField = { ...attributes, type: "date", uuid };
            this.options.inlineFields = [...this.options.inlineFields, newField];
            this.options.onEditorInlineFieldsChange(this.options.inlineFields);
            return chain()
              .insertContent({
                type: this.name,
                attrs: newField,
              })
              .run();
          },
    };
  },
});
